import { apiClient } from "../lib/apiClient";
import type { AuditLogEntry } from "../types";

export interface AuditLogPage {
  logs: AuditLogEntry[];
  nextCursor: string | null;
}

export async function listAuditLogs(filters?: {
  entityType?: string;
  action?: string;
  cursor?: string;
}): Promise<AuditLogPage> {
  const params = new URLSearchParams();
  if (filters?.entityType) params.set("entityType", filters.entityType);
  if (filters?.action) params.set("action", filters.action);
  if (filters?.cursor) params.set("cursor", filters.cursor);
  const { data } = await apiClient.get<AuditLogPage>(`/audit-logs?${params.toString()}`);
  return data;
}
